import React from 'react';

const SendUsAMessage = () => {
  return (
    <section className="section section-bg" id="call-to-action" style={{ backgroundImage: 'url(/assets/images/vvipgals.jpg)' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="cta-content">
              <h2>Send us a <em>message</em></h2>
              <p>Still not satisfied, you can contact us directly through our various platforms for any questions that you would like us to answer.</p>
              <div className="main-button">
                <a href="/bookings">Contact us</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

export default SendUsAMessage;
